<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <p class="title">
          {{`休假人员：${info.name}`}}
        </p>
        <img src="../assets/img/resources/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="item long">
        <span class="required"></span>
        <span class="name">休假时间</span>
        <date-picker :type="'datetime'" :format="'YYYY-MM-DD HH:mm'" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
      </div>
      <div class="btn" @click="confirmVacation()">
        确定
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'dealVacation',
  components: {
    DatePicker
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n, o) {
        this.start = common.stampToTime(n[0])
        this.end = common.stampToTime(n[1])
      }
    }
  },
  data() {
    return {
      show: false,
      datePicker: '',
      start: '',
      end: '',
      info: {
        name: '',
        id: ''
      }
    }
  },
  methods: {
    open(l) {
      this.info.name = l.title
      this.info.id = l.id
      this.show = true
    },
    close() {
      this.show = false
    },
    confirmVacation() {
      if (!this.start || !this.end) {
        this.$toast('请选择时间')
        return
      }

      const info = {
        person_id: this.info.id,
        rest_start: this.start,
        rest_end: this.end
      }

      common.myFetch(apis.Res_people_vacation_on, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.close()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 11111;
  background-color: rgba(0,0,0,0.70);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 680px;
    height: auto;
    padding: 20px 30px;
    .headline {
      height: 34px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .title {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        cursor: pointer;
      }
    }
    .item {
      width: 50%;
      margin: 13px 0;
      height: 30px;
      display: flex;
      align-items: center;
      .required {
        color: @red;
        width: 10px;
        font-size: 24px;
        font-family: Helvetica, sans-serif;
        margin-right: 10px;
      }
      .name {
        width: 52px;
        font-size: 14px;
        color: @sub;
        text-align-last: justify;
        margin-right: 30px;
        word-break: keep-all;
      }
      .input {
        box-sizing: border-box;
        width: 180px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #dcdcdc;
        padding-left: 38px;
        font-size: 14px;
        color: @dark;
        display: flex;
        align-items: center;
        overflow: hidden;
        select {
          font-size: 14px;
          height: 100%;
          flex: 1;
          border: none;
          outline: none;
        }
        input {
          font-size: 14px;
          height: 100%;
          flex: 1;
          box-sizing: border-box;
          background-color: transparent;
        }
        .down {
          margin: 0 10px;
        }
      }
    }
    .item:nth-child(2n) {
      justify-content: flex-end;
    }
    .long {
      width: 100% !important;
      justify-content: flex-start !important;
      .input {
        width: 100%;
      }
    }
    .btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 100px;
      background-color: @green;
      color: #fff;
      font-size: 14px;
      margin: 30px auto 0;
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
  }
}
</style>
